import styled from 'styled-components';

export const ComboContainer = styled.div`
	> strong {
		display: block !important;
		padding: 16px 0 !important;
		margin: 0 auto !important;
		width: fit-content !important;
		text-align: center !important;
		color: var(--ticto-primary) !important;
	}

	.combo {
		background: var(--ticto-ob-bg) !important;
		border: 2px solid var(--ticto-ob-outline) !important;
		border-radius: 08px !important;
		padding: 16px !important;
		margin: 0 16px !important;
		width: calc(100% - 32px) !important;

		& + .combo {
			margin-top: 08px !important;
		}

		> strong {
			display: block !important;
			font-size: 14px !important;
			margin-bottom: 08px !important;
		}

		.pack {
			display: flex !important;
			gap: 16px !important;
			align-items: center !important;

			img {
				border-radius: 08px !important;
				width: 80px !important;
				aspect-ratio: 1 / 1 !important;
				object-fit: cover !important;
			}

			p {
				font-size: 13px !important;
			}
		}

		.comboOffer {
			display: grid !important;
			grid-template-columns: 1fr auto !important;
			gap: 16px !important;
			align-items: center !important;
			padding: 08px 0 !important;

			& + .comboOffer {
				border-top: 1px dashed var(--ticto-ob-outline) !important;
			}

			.details {
				display: flex !important;
				gap: 12px !important;
				align-items: center !important;

				img {
					border-radius: 08px !important;
					width: 4rem !important;
					aspect-ratio: 1 / 1 !important;
					object-fit: cover !important;

					&.highlight {
						width: 5.5rem !important;
					}
				}

				.info {
					strong {
						font-size: 14px !important;
					}
				}
			}

			.pricing {
				text-align: right !important;

				* {
					font-size: 13px !important;
				}

				.price {
					color: var(--ticto-success) !important;
					display: block !important;
				}
			}
		}
	}
`;
